module.exports = __webpack_public_path__ + "img/81.ab18790b.jpg";